import { useMemo, useState } from "react";
import SectionHeading from "@/pages/home/components/SectionHeading";
import { shortVideoCategories, shortVideoFilters } from "@/mocks/content";

export default function ShortVideo() {
  const [active, setActive] = useState("all");

  const categories = useMemo(
    () => (active === "all" ? shortVideoCategories : shortVideoCategories.filter((c) => c.group === active)),
    [active]
  );

  return (
    <section id="video" className="w-full bg-background-100 py-16 md:py-24 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <SectionHeading
            eyebrow="短视频题材分类"
            title="短视频按题材筛，刷起来才不累"
            desc="短视频和直播的组织方式不同，它以题材为标签。下面按常见题材归类，每条都标注了大致时长与内容特点，方便按心情挑选。"
          />
          <div className="text-sm text-foreground-500 shrink-0">
            当前显示 <span className="font-heading font-bold text-primary-600 text-lg">{categories.length}</span> 类
          </div>
        </div>

        <div className="mt-8 flex flex-wrap gap-2">
          {shortVideoFilters.map((f) => (
            <button
              key={f.id}
              type="button"
              onClick={() => setActive(f.id)}
              className={`px-1 py-1 rounded-full text-sm transition-colors cursor-pointer ${
                active === f.id ? "bg-secondary-500 text-background-50" : "bg-background-50 text-foreground-700 border border-background-300 hover:border-secondary-400"
              }`}
            >
              <span className="block px-3 py-1.5 whitespace-nowrap">{f.label}</span>
            </button>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((c) => (
            <article
              key={c.id}
              className="flex rounded-lg overflow-hidden bg-background-50 border border-background-200/80 hover:border-secondary-400 transition-colors"
            >
              <div className="relative w-32 sm:w-36 shrink-0 overflow-hidden">
                <img
                  src={c.cover}
                  alt={`${c.title}短视频题材封面`}
                  title={`快猫短视频 ${c.title}`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex-1 p-4 md:p-5 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="font-heading font-bold text-base text-foreground-950">{c.title}</h3>
                </div>
                <div className="mt-1 inline-flex items-center gap-1 text-[11px] text-accent-800 bg-accent-100 px-2 py-0.5 rounded-full">
                  <i className="ri-timer-line"></i>
                  {c.count}
                </div>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{c.desc}</p>
                <div className="mt-3 flex flex-wrap gap-2">
                  {c.tags.map((t) => (
                    <span key={t} className="text-[11px] text-secondary-800 bg-secondary-100 px-2 py-0.5 rounded-full">
                      #{t}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}